import React from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Icon } from "@iconify/react";
// import img from "../../assets/images/money.png";
interface BalanceCardProps {
  balance: number;
  income: number;
  expense: number;
  onSend?: () => void;
  onReceive?: () => void;
  className?: string;
}

const BalanceCard: React.FC<BalanceCardProps> = ({
  balance,
  income,
  expense,
  onSend,
  onReceive,
  className = "",
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <Card
      className={`${className}`}
      style={{
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)), rgba(96, 74, 227, 1)",
      }}
    >
      <CardContent>
        <div className="flex flex-col h-full">
          <div className="flex-1">
            <h3 className="text-3xl font-bold text-primary dark:text-primary mb-1 text-[24px]">
              {formatCurrency(balance)}
            </h3>
            <p className="text-surface-2 text-[14px]">My Balance</p>
            <div className="flex gap-4 mt-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-green-500/50 rounded-lg flex items-center justify-center">
                  <Icon
                    icon="ri:arrow-down-line"
                    className="w-5 h-5 text-white"
                  />
                </div>
                <div>
                  <h5 className="text-primary dark:text-primary font-medium text-[15px]">
                    {formatCurrency(income)}
                  </h5>
                  <p className="text-surface-2 text-[14px]">Income</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-red-500/50 rounded-lg flex items-center justify-center">
                  <Icon
                    icon="ri:arrow-up-line"
                    className="w-5 h-5 text-white"
                  />
                </div>
                <div>
                  <h5 className="text-primary dark:text-primary font-medium text-[15px]">
                    {formatCurrency(expense)}
                  </h5>
                  <p className="text-surface-2 text-[14px]">Expense</p>
                </div>
              </div>
              <div className="flex items-center justify-center">
                {/* <img src={img} alt="money" className="w-12 h-12 object-contain" /> */}
              </div>
            </div>
          </div>
          <div className="flex gap-3 mt-6">
            <Button
              variant="default"
              size="sm"
              className="w-1/4 bg-orange-400 text-white"
              onClick={onSend}
            >
              Send
            </Button>
            <Button
              variant="outline"
              size="sm"
              className="w-1/4 bg-white/10 text-white hover:bg-white/20"
              style={{ backgroundColor: "rgba(47, 57, 67, 0.25)" }}
              onClick={onReceive}
            >
              Receive
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BalanceCard;
